import TourTooltipBeacon from "./TourTooltipBeacon";
export default TourTooltipBeacon;
